import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { ENTITY_LINK_REGEX } from "@bliks-io/contracts";
function refKey(type, id) {
    return `${type.toLowerCase()}:${id}`;
}
/**
 * "Sources" chip row under an assistant message. Shows the entities that
 * informed the answer but are NOT already linked inline in the text — inline
 * entity:// links render their own cards, so surfacing them again here would
 * duplicate. A ref needs a display name to render as a chip.
 */ export function MessageSources({ refs, text, renderEntityCard }) {
    const { t } = useTranslation();
    const inlineKeys = new Set();
    for (const [, type, id] of text.matchAll(ENTITY_LINK_REGEX)){
        inlineKeys.add(refKey(type, id));
    }
    const sources = refs.filter((ref)=>ref.name && !inlineKeys.has(refKey(ref.type, ref.id)));
    if (sources.length === 0) return null;
    return /*#__PURE__*/ _jsxs("div", {
        className: "mt-1 flex flex-col gap-1.5",
        children: [
            /*#__PURE__*/ _jsx("span", {
                className: "text-xs font-medium text-muted-foreground",
                children: t("chat.sourcesLabel")
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "flex flex-wrap gap-1.5",
                children: sources.map((ref)=>/*#__PURE__*/ _jsx(Fragment, {
                        children: renderEntityCard({
                            type: ref.type,
                            id: ref.id,
                            name: ref.name ?? ""
                        })
                    }, `${ref.type}:${ref.id}`))
            })
        ]
    });
}

//# sourceMappingURL=message-sources.js.map